
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 20 17","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M19 8.2L10.901 1v4.5s-6.893-.45-8.864 3.869c-1.44 2.97-.99 5.31-.9 5.67-.027-.109.45-.604.522-.703.198-.252.414-.495.63-.738.432-.468.9-.9 1.404-1.286.729-.558 1.557-1.008 2.448-1.251.98-.261 1.988-.162 2.996-.162h1.764v4.5L19 8.198z","stroke":"#221B38","stroke-width":"1.5","stroke-miterlimit":"10","stroke-linecap":"round","stroke-linejoin":"round"}})])
          )
        }
      }
    